<div class="container-fluid" dir={{direction}}>
  <div class="row">
    <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3 col-sm-8 offset-sm-2 rest-password-form">
      <a class="central_logo"> <img class="img-fluid" alt="IPOS Central LOGO" /> </a>
      <div class="card rest_pwd_message">
        <a [href]="href" class="popup_close">
          <img class="exit_image" alt="go to login page" />
        </a>
        <div class="form_header" [innerHTML]="modalTitle">
        </div>
        <span i18n="@@reset-password.password-changed">Your password has been successfully reset.</span>
        <div class="mt-2">
          <span i18n="@@reset-password.log-in-new-password">Log in with your new password</span>
        </div>
      </div>
    </div>
  </div>
</div>